// FIXME:типизация
export const processTimeBlocksFromServer = (
  timeBlocksFromServer: any,
  day: any,
): {
  id: number;
  start: Date;
  end: Date;
  price: number;
  tables: any[];
  availableTableNumbers: string;
  availableTablesCount: number;
  disabled: boolean;
  coach_disq: number;
  personal_disq: number;
  table_disq: number;
} => {
  return timeBlocksFromServer.map((block: any) => {
    const availableTablesCount = block.tables.filter((table: any) => !table.reserved).length;
    const isDisabled = availableTablesCount === 0;

    const splittedStartTime = block.start_time.replace(/"/g, '').split('+')[0].split(':');
    const splittedEndTime = block.end_time.replace(/"/g, '').split('+')[0].split(':');

    const availableTables = block.tables.filter((table: any) => !table.reserved);
    const availableTableNumbers = availableTables.map((table: any) => table.table_number).join(' ');

    const startTime = new Date(day);
    startTime.setHours(splittedStartTime[0]);
    startTime.setMinutes(splittedStartTime[1]);

    const endTime = new Date(day);
    if (splittedEndTime[0] === '00' && splittedEndTime[1] === '00') {
      // Если время конца блока - полночь, установим его на начало следующего дня
      endTime.setDate(endTime.getDate() + 1);
      endTime.setHours(0);
      endTime.setMinutes(0);
    } else {
      endTime.setHours(splittedEndTime[0]);
      endTime.setMinutes(splittedEndTime[1]);
    }

    return {
      id: block.id,
      start: startTime,
      end: endTime,
      price: block.price,
      tables: block.tables,
      availableTableNumbers: availableTableNumbers,
      availableTablesCount: availableTablesCount,
      disabled: isDisabled,
      coach_disq: block.coach_disq,
      personal_disq: block.personal_disq,
      table_disq: block.table_disq,
    };
  });
};
